<template>
  <CmPage
    v-if="activeTypeConfig"
    class="statistics"
  >
    <div
      slot="page-header"
      class="page__title"
    >
      <h1>{{ activeTypeConfig.title }}</h1>
    </div>

    <template #page-buttons>
      <p class="cm-constructor-page__description">
        {{ activeTypeConfig.description }}
      </p>
    </template>

    <StatAndAudit slot="page-content" />
  </CmPage>
</template>

<script>
import CmPage from "@/components/library/CmPage.vue";
import StatAndAudit from "@/components/statistics/StatAndAudit";

export default {
  name: "Statistics",

  components: {
    CmPage,
    StatAndAudit,
  },

  data() {
    return {
      activeTab: 1,
    };
  },

  computed: {
    activeTypeConfig() {
      return this.$t(`campaign.statistics.activeTypeConfig.${this.$route.params.type}`) || null;
    },
  },

  created() {
    if (!this.activeTypeConfig) {
      this.$router.push({
        name: "statistics-general", params: { type: "promotions" },
      });
      this.$forceUpdate();
    }
  },
};
</script>

<style lang="scss">
.statistics {
  .cm-page__header {
    border-bottom: 1px solid #ddd;
  }
  &.cm-page {
    overflow-y: auto;
  }
}
</style>